// eslint-disable-next-line
import React, { useEffect, useState } from 'react';
import { AppBar, Backdrop, CssBaseline, Divider, Drawer, IconButton, Slide, Toolbar, useScrollTrigger } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import styles from './Layout2.module.scss';
import Navigation from '@nal/components/Navigation/Navigation';
import { Navigations } from '@nal/navigation';
import CurrentUser from '../CurrentUser/CurrentUser';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import { useDispatch } from 'react-redux';
import { CurrentUserAction } from '../CurrentUser/store/actions';

const drawerWidth = 250;
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        menuButton: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(2),
        },
        drawer: {
            width: drawerWidth,
        },
        backdrop: {
            zIndex: theme.zIndex.drawer - 1,
            color: '#fff',
          },
    }),
);
interface LayoutPropType {
    window?: () => Window;
    children: React.ReactElement;
}

function HideOnScroll(props: LayoutPropType) {
    const { children, window } = props;
    const trigger = useScrollTrigger({ target: window ? window() : undefined });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

export default function Layout(props: LayoutPropType) {
    const classes = useStyles();
    const [openDraw, setOpenDraw] = useState(false);
    const [fixedDraw, setFixedDraw] = useState(false);
    const navigations = Navigations;
    const dispatch = useDispatch();

    const handleDrawerToggle = () => {
        if (openDraw && fixedDraw) {
            setFixedDraw(false);
        }
        setOpenDraw(!openDraw);
    };

    const handleFixedDrawer = () => {
        setFixedDraw(!fixedDraw);
    };

    useEffect(() => {
        dispatch({
            type: CurrentUserAction.GET_ME
        });
    }, []);

    return (
        <React.Fragment>
            <CssBaseline />
            <HideOnScroll {...props}>
                <AppBar className={styles.AppBar}>
                    <Toolbar className={`${styles.Toolbar}`}>
                        <IconButton
                            edge="start"
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="menu"
                            onClick={handleDrawerToggle}
                        >
                            <MenuIcon />
                        </IconButton>
                        <CurrentUser />
                    </Toolbar>
                </AppBar>
            </HideOnScroll>

            <Drawer
                variant="persistent"
                BackdropProps={fixedDraw ? { invisible: true } : { invisible: false }}
                anchor="left"
                open={openDraw}
                onClose={handleDrawerToggle}
                classes={{ paper: classes.drawer }}
            >
                <div className={`${styles.ToolbarHeader}`}>
                    {fixedDraw && <IconButton onClick={handleDrawerToggle}>
                        <ChevronLeftIcon />
                    </IconButton>
                    }
                    {!fixedDraw && <IconButton onClick={handleFixedDrawer}>
                        <ChevronRightIcon />
                    </IconButton>
                    }
                </div>
                <Divider />
                <Navigation open={true} navigations={navigations}></Navigation>

            </Drawer>
            <Toolbar className={`${styles.Toolbar}`}/>
            <main className={`${styles.Main} ${fixedDraw ? styles.MainOpen : ''}`}>
                <React.Fragment>{props.children}</React.Fragment>
            </main>
            <Backdrop className={classes.backdrop} open={!fixedDraw && openDraw} onClick={handleDrawerToggle}></Backdrop>

        </React.Fragment>
    );
}
